export const closeWebview = async (): Promise<void> => {
  const { closeActivity } = await import('@bridge/sharee');
  void closeActivity();
};
